// Module
var code = "<div class=\"tmr-product-img-container\" layout layout-align=\"center center\" flex> <img class=\"tmr-product-img\" ng-src=\"{{$ctrl.product.$getImageUrl()}}\" tmr-on-error=\"{{$ctrl.noImage}}\" alt=\"product image\"/> </div> ";
// Exports
var _module_exports =code;;
var path = 'components/productImage/productImage.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;